import { render } from "./StatusesList.vue?vue&type=template&id=62a8afa7"
import script from "./StatusesList.vue?vue&type=script&lang=js"
export * from "./StatusesList.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__